module.exports = __webpack_public_path__ + "img/serviceSolution.2dbadbe7.png";